import { StyleSheet } from "aphrodite";

const styles = StyleSheet.create({
  permissionTags: {
    fontStyle: "italic",
    color: "grey"
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/users-and-permissions/users-listing/users-listing-styles.js